export enum ModalType {
  INFORMATION,
  WARNING,
  ERROR
}